import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Icon } from "@iconify/react";
import styles from "./stages_explainer.module.css";
import policyImplementation from "../FlowCharts/Policy-Implementation.png"

// Stage data to avoid repetition
const STAGES_DATA = [
  {
    id: "Initiation",
    title: "1. Initiation",
    steps: [
      "1.1 Identification of policy challenge",
      "1.2 Prioritization of identified policy challenges",
      "1.3 Stakeholder consultation on policy priorities",
      "1.4 Concept note development",
    ],
  },
  {
    id: "Development",
    title: "2. Development",
    steps: [
      "2.1 Appraisal (regulatory impact assessment, cost-benefit analysis)",
      "2.2 Development of draft policy/bill/regulation",
      "2.3 Stakeholder consultation on the draft policy/bill/regulation",
    ],
  },
  {
    id: "Validation",
    title: "3. Validation",
    steps: [
      "3.1 Review of draft policy/bill/regulation",
      "3.2 Stakeholder validation workshops",
    ],
  },
  {
    id: "Approval",
    title: "4. Approval",
    steps: [
      "4.1 Review by the committee of principal/permanent secretaries",
      "4.2 Cabinet memo from lead ministry",
      "4.3 Presentation to cabinet",
      "4.4 Cabinet feedback/modifications to policy/bill/regulation draft",
      "4.5 Socialization and policy advocacy",
    ],
  },
  {
    id: "Legislation",
    title: "5. Legislation",
    steps: [
      "5.1 Submission to parliamentary select committee",
      "5.2 Organizing workshops with parliamentary select committee(s)",
      "5.3 Public hearing",
      "5.4 Draft bill publication",
      "5.5 Parliamentary debate and passage of bill/regulation",
      "5.6 Presidential assent",
    ],
  },
  {
    id: "Implementation",
    title: "6. Implementation",
    steps: [
      "6.1 Development & approval of regulations",
        "6.1.1 Laws spell out regulations/legal instruments that guide procedures for implementation & enforcement",
        "6.1.2 Regulations are used to provide services, train people to understand the benefit of law",
        "6.1.3 Regulations generate impact & therefore very important",
      "6.2 Interpretation & translation of law by policy enforcers",
        "6.2.1 This includes Local authorities, regulatory inspectors, customs officers, policemen, magistrates and judges",
        "6.2.2 Alignment, interpretation and consistency of enforcement of regulations",
      "6.3 Development of standard operating procedures",
        "6.3.1 SoPs guidelines or official documentation for government to operationalize the policies, laws and regulations",
      "6.4 Capacity building",
        "6.4.1 Human resource capacity building of implementing agencies",
        "6.4.2 Changing mindsets, attitudes & culture",
        "6.4.3 Strengthening the mandated institutions",
      "6.5 Strategic advocacy",
        "6.5.1 Direct advocacy & advocacy through non-state actors, and policy champions",
        "6.5.2 Policy dialogue platforms emerging as a powerful tool to influence policy implementation",
      "6.6 Resource mobilization",
        "6.6.1 Advocating for allocation of funding in the government budget and spending within the specified time frames",
      "6.7 Monitoring & evaluation",
        "6.7.1 Analytics to determine whether the policy is addressing the problem and if implementation is proceeding well",
        "6.7.2 Supporting advocacy by watchdogs (CSOs, associations) for implementation of regulations to ensure that regulations are within the constitutional framework",
        "6.7.3 Analytics to guide revisions in the agenda formulation or implementation"
    ],
  },
];

// Component to render a single stage
const Stage = ({ title, steps }) => (
  <div>
    <h5>{title}</h5>
    <ol>
      {steps.map((step, index) => {
        // Extract step number (e.g., 6.1.1) and the text
        const match = step.match(/^(\d+(\.\d+)*)(.*)/); // Matches numbers with dots (e.g., 6.1.1)
        const stepNumber = match ? match[1] : ""; // Extracts "6.1.1"
        const stepText = match ? match[3] : step; // Extracts description

        // Determine indentation level based on the number of dots
        const level = stepNumber.split(".").length - 1; // e.g., "6.1.1" has 2 dots (level 2)

        return (
          <li
            key={index}
            style={{
              paddingLeft: `${level * 20}px`, // Increase padding for sub-steps
              fontWeight: level === 0 ? "bold" : "normal", // Bold main steps
              listStyleType: level > 0 ? "none" : "decimal", // Remove bullet points for sub-steps
            }}
          >
            <span style={{ color: "#4D4D4D", fontWeight: "bold", paddingRight: "4px" }}>
              {stepNumber}
            </span>
            {stepText}
          </li>
        );
      })}
    </ol>
  </div>
);


const StagesExplainerModal = ({ isOpen, onOpenStateChanged, options = { stage: "all" } }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const handleClose = () => {
    onOpenStateChanged(false);
  };

  return (
    <Modal isOpen={isOpen} className="modal-lg" size="lg" toggle={handleClose}>
      <ModalHeader className={styles["stage-explainer-modal-header"]}>
          <h4> 📌 Stages Explainer</h4>
      </ModalHeader>
      <ModalBody className={styles["stage-explainer-modal-body"]}>
        <p>
         🧩 In APRITS every legal framework can be broken down into 6 distinct changes, below is an explanation of each stage and the activities that happen per stage.
        </p>

        {/*  <div className={`${styles.stages_explainer} grid gap-4 ${options.stage === 'all' ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1'}`}>*/}
        {/*  {STAGES_DATA.map((stage, index) =>*/}
        {/*    (options.stage === "all" || options.stage === stage.id) && (*/}
        {/*      <div*/}
        {/*        key={stage.id}*/}
        {/*        className={stage.id === "Implementation" ? "col-span-1 md:col-span-2 lg:col-span-3" : ""}*/}
        {/*      >*/}
        {/*        <Stage title={stage.title} steps={stage.steps} />*/}
        {/*      </div>*/}
        {/*    )*/}
        {/*  )}*/}
        {/*</div>*/}
          <div className={`${styles.stages_explainer} flex flex-wrap justify-center gap-4`}>
          {STAGES_DATA.map((stage) =>
            (options.stage === "all" || options.stage === stage.id) && (
              <div
                key={stage.id}
                className={`
                  ${stage.id === "Implementation" ? "w-full" : "w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]"}
                  ${["Approval", "Legislation"].includes(stage.id) ? "md:flex-grow-0" : ""}
                `}
              >
                <Stage title={stage.title} steps={stage.steps} />
              </div>
            )
          )}
        </div>


        <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            ⚙️ Policy Implementation Model
        </h3>

        <div style={{ position: "relative", display: "inline-block" }}>
            {/* Flowchart Image */}
            <img
              src={policyImplementation}
              alt="Landscaping Process Flowchart"
              style={{ width: "100%", borderRadius: "8px", marginTop: "10px", cursor: "pointer" }}
              onClick={() => setIsZoomed(true)}
            />
            {/* Zoom Button (Magnifying Glass) */}
            <button
              onClick={() => setIsZoomed(true)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "20px",
                cursor: "pointer"
              }}
            >
              🔍 <span style={{ fontSize: "10px", color: "black" }}>Zoom</span>
            </button>
          </div>

      {/* Zoomed Image Modal */}
          {isZoomed && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "1000"
              }}
              onClick={() => setIsZoomed(false)}
            >
              <img
                src={policyImplementation}
                alt="Zoomed Landscaping Process Flowchart"
                style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
              />
            </div>
          )}
      </ModalBody>
      <ModalFooter className={styles["modal-footer"]}>
         <Button style={{
          backgroundColor: "#036F36",
          color: "#FFF605",
          borderRadius: "2.25rem",
          width: "auto",
          fontSize: "16px",
          fontWeight: "bold",
          padding: "10px",
          border: "none",
          margin: "0 auto",
            display: "block"
        }} onClick={handleClose}>
            Dismiss
          </Button>
      </ModalFooter>
    </Modal>
  );
};

const StagesExplainer = ({ stage, previewcontent }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      {previewcontent ? (
        <Button className="w-full bg-white text-black p-0 border-none" onClick={() => setIsOpen(!isOpen)}>
          {previewcontent}
        </Button>
      ) : (
        <button className="btn stages-explainer btn-primary" onClick={() => setIsOpen(!isOpen)}>
          <Icon icon="hugeicons:information-circle" />
        </button>
      )}
      <StagesExplainerModal isOpen={isOpen} options={{ stage }} onOpenStateChanged={setIsOpen} />
    </div>
  );
};

export default StagesExplainer;